import { createSlice } from '@reduxjs/toolkit';

import { getFiles, removeFile, uploadFiles } from '@webapp/account/src/resources/filemanager/async';
import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { initialState } from './state';

export const filemanagerSlice = createSlice({
    name: 'filemanager',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        addStateFetch(
            builder
                // uploadFile
                .addCase(uploadFiles.pending, (state) => {
                    state.uploadFetch = true;
                })
                .addCase(uploadFiles.fulfilled, (state, { payload: { files } }) => {
                    state.error = null;
                    state.uploadFetch = false;
                    state.uploadProgress = 100;
                    state.files = [...files, ...state.files];
                })
                .addCase(uploadFiles.rejected, (state, { payload }) => {
                    const data = payload as { message: string };

                    state.error = data?.message;
                    state.uploadFetch = false;
                    state.uploadProgress = 0;
                })
                // getFiles
                .addCase(getFiles.pending, (state) => {
                    state.fetch = true;
                    state.loaded = false;
                })
                .addCase(getFiles.fulfilled, (state, { payload: { files } }) => {
                    state.files = files;
                    state.fetch = false;
                    state.loaded = true;
                })
                .addCase(getFiles.rejected, (state) => {
                    state.fetch = false;
                })
                // removeFile
                .addCase(removeFile.fulfilled, (state, { payload: { fileId } }) => {
                    state.files = state.files.filter(({ id }) => id !== fileId);
                }),
        ),
});
